import {Button, Box, IconButton, Tooltip, Typography} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import AssessmentRoundedIcon from "@mui/icons-material/AssessmentRounded";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import KitchenRoundedIcon from "@mui/icons-material/KitchenRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import AddShoppingCartRoundedIcon from "@mui/icons-material/AddShoppingCartRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import RestaurantMenuRoundedIcon from "@mui/icons-material/RestaurantMenuRounded";
import RoomServiceRoundedIcon from "@mui/icons-material/RoomServiceRounded";
import ChecklistRoundedIcon from "@mui/icons-material/ChecklistRounded";
import DeleteSweepRoundedIcon from "@mui/icons-material/DeleteSweepRounded";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import {useNavigate, useLocation} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import {printOrder} from "../../utils/ordersControlar.js";
import {useGlobalOrder} from "../../utils/GlobalStateContext";
import {BRAND, BRAND_ASSETS} from "../../brand";
import {collectPausedProducts, formatBadgeCount} from "../PausedProducts/pausedProducts";

const Sidebar = ({setTodayOrders, systemData, setSystemLogin, menuItems, setCurrentTab, setUrlType, urlType, collapsed, onToggleCollapsed}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const {playBeep, chatUnread, pendingMakeCount} = useGlobalOrder(); // 全局 toast 提示 / LINE 未讀數 / 未出餐單數
    // 選單紅字：訊息未讀、未出餐單數、暫停販售品項數
    const menuBadges = {13: chatUnread, 5: pendingMakeCount, 3: collectPausedProducts(systemData).length};
    const iconById = {
        0: <HomeRoundedIcon />,
        1: <AddShoppingCartRoundedIcon />,
        2: <ReceiptLongRoundedIcon />,
        3: <RestaurantMenuRoundedIcon />,
        4: <Inventory2RoundedIcon />,
        5: <RoomServiceRoundedIcon />,
        6: <AssessmentRoundedIcon />,
        7: <LogoutRoundedIcon />,
        8: <KitchenRoundedIcon />,
        9: <ChecklistRoundedIcon />,
        10: <SupportAgentRoundedIcon />,
        13: <ForumRoundedIcon />,
        14: <CalendarMonthRoundedIcon />,
        15: <DeleteSweepRoundedIcon />,
    };
    const getLabel = (item) => (urlType === 2 && item.id === 5) ? "已出單" : item.label;
    // 機台身分徽章：一眼看出這台登入的是哪個角色，避免登錯帳號沒發現
    const positionBadge = {
        1: { background: "#F2C94C", color: "#3C2A00", short: "結帳" }, // 結帳台
        2: { background: "#B45309", color: "#FFF", short: "炒台" },    // 內場炒台
        3: { background: "#1D4ED8", color: "#FFF", short: "出餐" },    // 內場出餐台
    }[Number(systemData?.position_id)] || { background: "rgba(255,255,255,0.16)", color: "#FFF", short: "" };
    const positionName = systemData?.name || "";
    const topItems = menuItems.filter((item) => item.id !== 7);
    const bottomItems = menuItems.filter((item) => item.id === 7);
    const ITEM_HEIGHT = collapsed ? 56 : 58;
    const ITEM_GAP = 8;
    const activeIndex = topItems.findIndex((item) => location.pathname === item.path);
    const EASE = "cubic-bezier(0.22, 1, 0.36, 1)";
    const [pillAnimated, setPillAnimated] = useState(false);
    const hasMountedRef = useRef(false);
    useEffect(() => {
        if (!hasMountedRef.current) {
            hasMountedRef.current = true;
            const id = requestAnimationFrame(() => setPillAnimated(true));
            return () => cancelAnimationFrame(id);
        }
    }, []);
    const renderIcon = (item, active) => {
        return (
            <Box
                sx={{
                    display: "flex",
                    color: active ? "#1C2D42" : "rgba(255,255,255,0.82)",
                    transition: `color 220ms ${EASE}`,
                    "& svg": {
                        fontSize: collapsed ? 26 : 24,
                        transition: `font-size 220ms ${EASE}`,
                    },
                }}
            >
                {iconById[item.id] || (
                    <Typography sx={{ fontSize: 18, fontWeight: 800, lineHeight: 1 }}>
                        {getLabel(item).slice(0, 1)}
                    </Typography>
                )}
            </Box>
        );
    };
    const renderMenuItem = (item) => {
        const active = location.pathname === item.path;
        return (
            <Tooltip
                key={item.label}
                title={collapsed ? getLabel(item) : ""}
                placement="right"
            >
                <Button
                    fullWidth
                    size="large"
                    onClick={(e) => {
                        e.stopPropagation();
                        if (collapsed) {
                            onToggleCollapsed();
                        }
                        if (window.location.href.includes("dining-out") && item.id === 5) {
                            setUrlType(urlType === 1 ? 2 : 1);
                        } else {
                            navigate(item.path);
                        }
                        setCurrentTab(item.id);
                        //playBeep();
                    }}
                    sx={{
                        minWidth: 0,
                        width: "100%",
                        height: ITEM_HEIGHT,
                        px: collapsed ? 0 : 1.5,
                        justifyContent: collapsed ? "center" : "flex-start",
                        gap: collapsed ? 0 : 1.5,
                        borderRadius: "16px",
                        position: "relative",
                        overflow: "hidden",
                        textTransform: "none",
                        backgroundColor: "transparent",
                        color: active ? "#1C2D42" : "rgba(255,255,255,0.84)",
                        zIndex: 1,
                        transition: `padding 220ms ${EASE}, gap 220ms ${EASE}, color 220ms ${EASE}, height 220ms ${EASE}`,
                        "&:hover": {
                            backgroundColor: active ? "transparent" : "rgba(255,255,255,0.08)",
                        },
                    }}
                >
                    <Box
                        sx={{
                            width: 32,
                            height: 32,
                            borderRadius: "10px",
                            backgroundColor: active ? "#FFD35A" : "rgba(255,255,255,0.08)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flex: "0 0 32px",
                            position: "relative",
                            transition: `background-color 220ms ${EASE}`,
                        }}
                    >
                        {renderIcon(item, active)}
                        {menuBadges[item.id] > 0 ? (
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: -6,
                                    right: -8,
                                    minWidth: 18,
                                    height: 18,
                                    px: 0.4,
                                    borderRadius: "999px",
                                    backgroundColor: "#D32F2F",
                                    color: "#FFF",
                                    fontSize: 11,
                                    fontWeight: 800,
                                    lineHeight: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    zIndex: 2,
                                }}
                            >
                                {formatBadgeCount(menuBadges[item.id])}
                            </Box>
                        ) : null}
                    </Box>
                    <Typography
                        sx={{
                            fontSize: 16,
                            lineHeight: "20px",
                            fontWeight: active ? 800 : 600,
                            letterSpacing: 0,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            maxWidth: collapsed ? 0 : 160,
                            opacity: collapsed ? 0 : 1,
                            transition: `max-width 220ms ${EASE}, opacity 180ms ${EASE}, font-weight 220ms ${EASE}`,
                        }}
                    >
                        {getLabel(item)}
                    </Typography>
                </Button>
            </Tooltip>
        );
    };

    return (
        <Box
            onClick={() => {
                if (collapsed) {
                    onToggleCollapsed();
                }
            }}
            sx={{
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                p: collapsed ? "12px 12px" : "16px 14px",
                gap: 1.5,
                position: "relative",
                overflow: "visible",
                cursor: collapsed ? "pointer" : "default",
            }}
        >
            <Tooltip title={collapsed ? "展開選單" : "收合選單"} placement="right">
                <IconButton
                    aria-label={collapsed ? "展開選單" : "收合選單"}
                    onClick={(e) => {
                        e.stopPropagation();
                        onToggleCollapsed();
                    }}
                    sx={{
                        position: "absolute",
                        top: "50%",
                        right: -14,
                        transform: "translateY(-50%)",
                        zIndex: 20,
                        width: 28,
                        height: 28,
                        p: 0,
                        color: "#1C2D42",
                        backgroundColor: "#FFF",
                        border: "2px solid #FFF",
                        boxShadow: "0 6px 18px rgba(0,0,0,0.28)",
                        transition: "transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease",
                        "&:hover": {
                            backgroundColor: "#FFD35A",
                            boxShadow: "0 8px 22px rgba(0,0,0,0.32)",
                            transform: "translateY(-50%) scale(1.08)",
                        },
                        "& svg": { fontSize: 18 },
                    }}
                >
                    {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                </IconButton>
            </Tooltip>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: collapsed ? "center" : "flex-start",
                    flexDirection: collapsed ? "column" : "row",
                    gap: collapsed ? 0.5 : 1.25,
                    minHeight: 56,
                    mb: 0.5,
                }}
            >
                <Box
                    component="img"
                    src={BRAND_ASSETS.markDark}
                    alt={BRAND.name}
                    sx={{ width: collapsed ? 28 : 32, height: collapsed ? 28 : 32, flex: "0 0 auto" }}
                />
                {!collapsed ? (
                    <Box sx={{ minWidth: 0 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                            <Typography sx={{ color: "#FFF", fontSize: 18, fontWeight: 900, lineHeight: "22px" }}>
                                POS
                            </Typography>
                            {positionName ? (
                                <Box
                                    component="span"
                                    sx={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        px: 0.9,
                                        py: 0.3,
                                        borderRadius: "8px",
                                        backgroundColor: positionBadge.background,
                                        color: positionBadge.color,
                                        fontSize: 13,
                                        fontWeight: 900,
                                        lineHeight: 1.2,
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {positionName}
                                </Box>
                            ) : null}
                        </Box>
                        <Typography
                            sx={{
                                color: "rgba(255,255,255,0.56)",
                                fontSize: 12,
                                lineHeight: "16px",
                                maxWidth: 142,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {systemData.store_name || "餐飲管理"}
                        </Typography>
                    </Box>
                ) : (
                    <Box
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: "12px",
                            backgroundColor: positionName ? positionBadge.background : "rgba(255,255,255,0.12)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Typography
                            sx={{
                                color: positionName ? positionBadge.color : "#FFF",
                                fontSize: positionName ? 12 : 14,
                                fontWeight: 900,
                                letterSpacing: 0.5,
                                textAlign: "center",
                                lineHeight: 1.15,
                            }}
                        >
                            {positionBadge.short || (positionName ? positionName.slice(0, 2) : "POS")}
                        </Typography>
                    </Box>
                )}
            </Box>
            <Box
                display="flex"
                flexDirection="column"
                sx={{
                    position: "relative",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    overflowY: "auto",
                    width: "100%",
                    flex: 1,
                    gap: `${ITEM_GAP}px`,
                }}
                className="hide-scrollbar"
            >
                <Box
                    aria-hidden
                    sx={{
                        position: "absolute",
                        left: 0,
                        right: 0,
                        top: 0,
                        height: ITEM_HEIGHT,
                        borderRadius: "16px",
                        backgroundColor: "#FFF",
                        border: "1px solid rgba(255,255,255,0.9)",
                        boxShadow: "0 12px 30px rgba(0,0,0,0.18)",
                        transform: `translateY(${activeIndex >= 0 ? activeIndex * (ITEM_HEIGHT + ITEM_GAP) : 0}px)`,
                        opacity: activeIndex >= 0 ? 1 : 0,
                        transition: pillAnimated
                            ? `transform 320ms ${EASE}, opacity 220ms ${EASE}, height 220ms ${EASE}`
                            : "none",
                        pointerEvents: "none",
                        zIndex: 0,
                        "&::before": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            top: 12,
                            bottom: 12,
                            width: 4,
                            borderRadius: "0 999px 999px 0",
                            backgroundColor: "#1C2D42",
                            opacity: collapsed ? 0 : 1,
                            transition: `opacity 200ms ${EASE}`,
                        },
                    }}
                />
                {topItems.map(renderMenuItem)}
            </Box>
        </Box>
    );
};


export default Sidebar;
